import React, { lazy, Suspense } from "react";
import { SuspenseLoader } from "../../../assets/loaders";

const LazyComponent = lazy(() => import("./ForgetPassword"));

export default function ForgetPassword() {
  return (
    <Suspense fallback={<SuspenseLoader />}>
      <LazyComponent />
    </Suspense>
  );
}